module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/speech_bubble-7a89f9df4b3a1ac273c3e0ae8fda2411.svg";